import { render, staticRenderFns } from "./Plpackingmaterials.vue?vue&type=template&id=c3bb3e22&scoped=true"
import script from "./Plpackingmaterials.vue?vue&type=script&lang=js"
export * from "./Plpackingmaterials.vue?vue&type=script&lang=js"
import style0 from "./Plpackingmaterials.vue?vue&type=style&index=0&id=c3bb3e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bb3e22",
  null
  
)

export default component.exports